import { GraduationCap, Languages, Briefcase } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import Reveal from "@/components/Reveal";

const FOUNDER_IMG = "/founder.png";
const KU_IMG =
  "https://images.unsplash.com/photo-1600706812693-933add24a785?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxiZWxnaXVtJTIwbGV1dmVuJTIwdW5pdmVyc2l0eSUyMGJ1aWxkaW5nfGVufDB8fHx8MTc5Mzc5Mjk4OHww&ixlib=rb-4.1.0&q=85";

const BADGE_ICONS = { graduation: GraduationCap, languages: Languages, briefcase: Briefcase };

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="despre" data-testid="section-about" className="relative overflow-hidden py-24 md:py-32">
      <div className="mx-auto grid max-w-7xl gap-16 px-6 lg:grid-cols-12 lg:gap-20">
        <div className="relative order-1 lg:col-span-5">
          <Reveal>
            <div className="relative">
              <div className="overflow-hidden rounded-b-[2rem] rounded-t-[12rem] border border-black/[0.06] shadow-[0_24px_60px_rgb(0,0,0,0.10)]">
                <img src={FOUNDER_IMG} alt="Iris, fondatoarea Iris Languages Academy" className="aspect-[15/16] w-full object-cover object-top" loading="lazy" />
              </div>

              <div className="absolute -left-4 top-10 flex items-center gap-3 rounded-2xl border border-black/[0.06] bg-white/85 p-3 pr-5 shadow-[0_12px_32px_rgb(0,0,0,0.10)] backdrop-blur-xl md:-left-10" data-testid="about-ku-badge">
                <img src={KU_IMG} alt="KU Leuven" className="h-12 w-12 rounded-xl object-cover" loading="lazy" />
                <span>
                  <span className="block font-display text-lg font-semibold leading-tight text-[#1A1A1A]">{t.about.badgeKU}</span>
                  <span className="block text-xs text-[#5C5C5C]">{t.about.badgeKUSub}</span>
                </span>
              </div>

              <div className="absolute -bottom-6 right-4 h-24 w-24 rounded-full bg-gradient-to-br from-[#FF6B6B]/70 via-[#F9D876]/70 to-[#45B7D1]/70 blur-2xl" aria-hidden="true" />
            </div>
          </Reveal>
        </div>

        <div className="order-2 lg:col-span-7">
          <Reveal>
            <p className="text-xs font-medium uppercase tracking-[0.28em] text-[#5C5C5C]">{t.about.eyebrow}</p>
            <h2 className="mt-5 max-w-xl font-display text-4xl font-medium leading-[1.1] tracking-tight text-[#1A1A1A] md:text-5xl">
              {t.about.title}
            </h2>
          </Reveal>

          <Reveal delay={0.08}>
            <div className="mt-8 space-y-5 text-base leading-relaxed text-[#5C5C5C] md:text-lg">
              <p>{t.about.p1}</p>
              <p>{t.about.p2}</p>
              <p>{t.about.p3}</p>
            </div>
          </Reveal>

          <Reveal delay={0.14}>
            <div className="mt-9 flex flex-wrap gap-3">
              {t.about.badges.map((badge, i) => {
                const Icon = BADGE_ICONS[t.about.badgeIcons[i]] || GraduationCap;
                return (
                  <span
                    key={badge}
                    className="inline-flex items-center gap-2.5 rounded-full border border-black/[0.08] bg-white/70 px-4 py-2 text-sm font-medium text-[#1A1A1A] backdrop-blur transition-transform duration-300 hover:-translate-y-0.5"
                    data-testid={`about-badge-${i}`}
                  >
                    <Icon className="h-4 w-4 text-[#45B7D1]" />
                    {badge}
                  </span>
                );
              })}
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <blockquote className="mt-10 border-l-2 border-[#FF6B6B] pl-6 md:pl-8">
              <p className="font-display text-2xl font-medium italic leading-snug text-[#1A1A1A] md:text-[1.75rem]">
                “{t.about.quote}”
              </p>
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
